import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaSignOutAlt, FaChartBar, FaCalendarAlt } from "react-icons/fa";
import { MdOutlineWorkOutline } from "react-icons/md";
import { BsPeople } from "react-icons/bs";
import { IoTimerOutline } from "react-icons/io5";

function Sidebar({ isMobileOpen = false, onMobileClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("");
  const [role, setRole] = useState(null);

  useEffect(() => {
    setActiveLink(location.pathname);

    const storedRole = localStorage.getItem("dx220");
    if (storedRole) {
      setRole(storedRole);
    }

    if (storedRole === "10" && !["/dashboard", "/agent"].includes(location.pathname)) {
      navigate("/dashboard");
    }
  }, [location.pathname, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("dx220");
    navigate("/login");
  };

  const handleNavClick = () => {
    onMobileClose?.();
  };

  const isRecruitmentsActive = activeLink === "/dashboard" || activeLink.startsWith("/details/");
  const isActive = (link) => link === activeLink;
  const navItemClass = (active) =>
    `flex items-center space-x-2 p-3 rounded-lg transition-colors min-h-[44px] ${
      active ? "bg-[#FAB615] text-gray-900 font-medium" : "hover:bg-amber-100 text-gray-700"
    }`;

  const sidebarContent = (
    <>
      <div className="flex items-center justify-between p-4 md:justify-around">
        <div className="flex items-center mt-4 md:mt-6">
          <img src="/logo.png" alt="Logo" className="h-24 w-24 md:h-40 md:w-40" />
        </div>
        <button
          type="button"
          onClick={onMobileClose}
          className="p-2.5 rounded-lg md:hidden text-gray-600 hover:bg-gray-100 min-h-[44px] min-w-[44px] flex items-center justify-center"
          aria-label="Fermer le menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <ul className="space-y-1 p-4 flex-grow">
         {role === "10" ? (
          <>
            <li className={navItemClass(isRecruitmentsActive)}>
              <MdOutlineWorkOutline className="font-bold flex-shrink-0" />
              <Link to="/dashboard" className="text-md block w-full py-2" onClick={handleNavClick}>
                Recrutements
              </Link>
            </li>
            <li className={navItemClass(isActive("/agent"))}>
              <BsPeople className="font-bold flex-shrink-0" />
              <Link to="/agent" className="text-md block w-full py-2" onClick={handleNavClick}>
                Agent
              </Link>
            </li>
          </>
        ) : (
          <>
            <li className={navItemClass(isActive("/statistics"))}>
              <FaChartBar className="font-bold flex-shrink-0" />
              <Link to="/statistics" className="text-md block w-full py-2" onClick={handleNavClick}>
                Statistiques
              </Link>
            </li>
            <li className={navItemClass(isRecruitmentsActive)}>
              <MdOutlineWorkOutline className="font-bold flex-shrink-0" />
              <Link to="/dashboard" className="text-md block w-full py-2" onClick={handleNavClick}>
                Recrutements
              </Link>
            </li>
            <li className={navItemClass(isActive("/availability"))}>
              <FaCalendarAlt className="font-bold flex-shrink-0" />
              <Link to="/availability" className="text-md block w-full py-2" onClick={handleNavClick}>
                Disponibilité
              </Link>
            </li>
            <li className={navItemClass(isActive("/agent"))}>
              <BsPeople className="font-bold flex-shrink-0" />
              <Link to="/agent" className="text-md block w-full py-2" onClick={handleNavClick}>
                Agent
              </Link>
            </li>
            <li className={navItemClass(isActive("/timesheet"))}>
              <IoTimerOutline className="font-bold flex-shrink-0" />
              <Link to="/timesheet" className="text-md block w-full py-2" onClick={handleNavClick}>
                Relevé d'heures
              </Link>
            </li>
          </>
        )}
      </ul>

      <div className="p-4 border-t border-gray-200">
        <button
          type="button"
          onClick={handleLogout}
          className="flex items-center text-red-600 space-x-2 p-3 w-full rounded-lg hover:bg-red-50 transition-colors min-h-[44px]"
        >
          <FaSignOutAlt className="inline-block mr-1 flex-shrink-0" />
          <span>Déconnexion</span>
        </button>
      </div>
    </>
  );

  return (
    <>
      {/* Mobile backdrop */}
      <div
        role="button"
        tabIndex={0}
        onClick={onMobileClose}
        onKeyDown={(e) => e.key === "Escape" && onMobileClose?.()}
        className={`fixed inset-0 bg-black/50 z-30 transition-opacity md:hidden ${isMobileOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        aria-hidden="true"
      />
      {/* Sidebar: drawer on mobile, fixed on desktop */}
      <div
        className={`h-screen w-60 max-w-[85vw] bg-gray-50 text-gray-600 flex flex-col fixed border-r border-gray-200 z-40 transition-transform duration-200 ease-out
          ${isMobileOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 md:w-60`}
      >
        {sidebarContent}
      </div>
    </>
  );
}

export default Sidebar;
